import {Style, Icon, Text, Fill, Stroke} from 'ol/style.js';
import {transformExtent} from 'ol/proj';
import {GeoJsonLayer} from '../GeoJsonLayer.js';
import Library from '../Library.js';

export class AirepLayer extends GeoJsonLayer {
    icon_cache = {};
    types = [ 'turb', 'icing', 'wx', 'misc' ];

    constructor( map, settings = {} ){
        settings["name"] = 'airep';
        settings["dynamic_time"] = true;
        settings["dynamic_level"] = true;
        settings["api_endpt"] = 'AirepJSON.php';
        if( settings.plottype == undefined ) settings['plottype'] = "model";
        if( settings.type == undefined ) settings['type'] = "all";
        if( settings.scale == undefined ) settings['scale'] = 1;
        if( settings.wxplot == undefined ) settings['wxplot'] = false;
        if( settings.bottom == undefined ) settings['bottom'] = undefined;
        if( settings.top == undefined ) settings['top'] = undefined;
        super( map, settings );
    }

    getUrl( extent, resolution, projection ){
        let extent1 = transformExtent(extent, projection, "EPSG:4326");
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "bbox", extent1.join(","));
        url.searchParams.set( "zoom", this.map.view.getZoom());
        url.searchParams.set( "type", this.settings['type'] );
        if( this.map.level != undefined ) url.searchParams.set( "level", this.map.level );
        if( this.settings['bottom'] != undefined ) url.searchParams.set( "bottom", this.settings['bottom'] );
        if( this.settings['top'] != undefined ) url.searchParams.set( "top", this.settings['top'] );
        url.searchParams.set( "date", Library.formatDate( "ymd_hn", this.map.secs ));
        return url.toString();
    }

    getIconSize( feature ){
        if( this.property(feature,'tb_type1') == "LLWS" ||
                this.property(feature,'tb_type1') == "MWAVE" )
            return 30*this.settings['scale'];
        if( this.property(feature,'tb_int1') != undefined ||
                this.property(feature,'tb_type1') != undefined ||
                this.property(feature,'icg_int1') != undefined )
            return 20*this.settings['scale'];
        else if( this.wxplot && (
                    this.property(feature,'temp') != undefined ||
                    this.property(feature,'wdir') != undefined ||
                    this.property(feature,'cloud_cvg1') != undefined ))
            return 80*this.settings['scale'];
        else
            return 20*this.settings['scale'];
    }

    getColor( feature ){
        let color = "000000";
        if( this.property(feature,'tb_int1') == "EXTM" )
            color = "cc00cc";
        else if( this.property(feature,'tb_int1') == "SEV-EXTM" )
            color = "cc00cc";
        else if( this.property(feature,'tb_int1') == "SEV" )
            color = "aa0000";
        else if( this.property(feature,'icg_int1') == "SEV" ||
                this.property(feature,'icg_int1') == "HVY" )
            color = "aa0000";
        else if( this.property(feature,'tb_int1') == "MOD-SEV" )
            color = "aa0000";
        else if( this.property(feature,'icg_int1') == "MOD-SEV" )
            color = "aa0000";
        else if( this.property(feature,'tb_type1') == "MWAVE" )
            color = "ff8800";
        else if( this.property(feature,'tb_type1') == "LLWS" )
            color = "aa0000";
        else if( this.property(feature,'tb_int1') == "MOD" )
            color = "ff8800";
        else if( this.property(feature,'icg_int1') == "MOD" )
            color = "ff8800";
        else if( this.property(feature,'tb_int1') == "LGT-MOD" )
            color = "ff8800";
        else if( this.property(feature,'icg_int1') == "LGT-MOD" )
            color = "ff8800";
        else if( this.property(feature,'tb_int1') == "LGT" )
            color = "00aa00";
        else if( this.property(feature,'icg_int1') == "LGT" )
            color = "00aa00";
        else if( this.property(feature,'tb_int1') == "SMTH-LGT" )
            color = "00aa00";
        else if( this.property(feature,'icg_int1') == "TRC-LGT" )
            color = "00aa00";
        else if( this.property(feature,'icg_int1') == "TRC" )
            color = "00aa00";
        else if( this.property(feature,'tb_int1') == "NEG" )
            color = "0000ff";
        else if( this.property(feature,'icg_int1') == "NEG" )
            color = "0000ff";
        if( this.property(feature,'airep_type') == "Urgent PIREP" )
            color = "aa0000";
        return color;
    }

    getHighlightColor( feature ){
        return "ffffff";
    }

    getIcon( feature ){
        let icon;
        let dir = 45;
        let color = "000000";
        if( this.property(feature,'airep_type') == "Urgent PIREP" )
            color = "aa0000";
        let text = "";
        let statmodel = "";
        let code = "PLANE";
        // Extreme turb
        if( this.property(feature,'tb_int1') == "EXTM" ){
            code = "TUR-X";
            color = "cc00cc";
            // Extreme/severe turb
        } else if( this.property(feature,'tb_int1') == "SEV-EXTM" ){
            code = "TUR-S";
            color = "cc00cc";
            // Severe turb
        } else if( this.property(feature,'tb_int1') == "SEV" ){
            code = "TUR-S";
            color = "aa0000";
            // Severe icing
        } else if( this.property(feature,'icg_int1') == "SEV" ||
                this.property(feature,'icg_int1') == "HVY"){
            code = "ICE-S";
            color = "aa0000";
            // Moderate/severe turb
        } else if( this.property(feature,'tb_int1') == "MOD-SEV" ){
            code = "TUR-MS";
            color = "aa0000";
            // Moderate/severe icing
        } else if( this.property(feature,'icg_int1') == "MOD-SEV" ){
            code = "ICE-M";
            color = "aa0000";
            // Mountain wave turb
        } else if( this.property(feature,'tb_type1') == "MWAVE" ){
            text = "MWAV";
            color = "ff8800";
            // Low level wind shear
        } else if( this.property(feature,'tb_type1') == "LLWS" ){
            code = "LLWS";
            color = "aa0000";
            // Moderate turb
        } else if( this.property(feature,'tb_int1') == "MOD" ){
            code = "TUR-M";
            color = "ff8800";
            // Moderate icing
        } else if( this.property(feature,'icg_int1') == "MOD" ){
            code = "ICE-M";
            color = "ff8800";
            // Light/moderate turb
        } else if( this.property(feature,'tb_int1') == "LGT-MOD" ){
            code = "TUR-LM";
            color = "ff8800";
            // Light/moderate icing
        } else if( this.property(feature,'icg_int1') == "LGT-MOD" ){
            code = "ICE-L";
            color = "ff8800";
            // Light turb
        } else if( this.property(feature,'tb_int1') == "LGT" ){
            code = "TUR-L";
            color = "00aa00";
            // Light icing
        } else if( this.property(feature,'icg_int1') == "LGT" ){
            code = "ICE-L";
            color = "00aa00";
            // Smooth/light turb
        } else if( this.property(feature,'tb_int1') == "SMTH-LGT" ){
            code = "TUR-TL";
            color = "00aa00";
            // Trace/light icing
        } else if( this.property(feature,'icg_int1') == "TRC-LGT" ){
            code = "ICE-TL";
            color = "00aa00";
            // Trace/light icing
        } else if( this.property(feature,'icg_int1') == "TRC" ){
            code = "ICE-T";
            color = "00aa00";
            // Negative turb
        } else if( this.property(feature,'tb_int1') == "NEG" ){
            code = "TUR-N";
            color = "0000ff";
            // Negative icing
        } else if( this.property(feature,'icg_int1') == "NEG" ){
            code = "ICE-N";
            color = "0000ff";
        } else if( this.wxplot && (
                    this.property(feature,'temp') != undefined ||
                    this.property(feature,'wdir') != undefined ||
                    this.property(feature,'cloud_cvg1') != undefined )){
            if( this.property(feature,'temp') != undefined )
                statmodel = statmodel + "temp="+this.property(feature,'temp') + "&";
            if( this.property(feature,'wdir') != undefined ){
                statmodel = statmodel + "wdir="+this.property(feature,'wdir') + "&";
                statmodel = statmodel + "wspd="+this.property(feature,'wspd') + "&";
            }
            statmodel = statmodel + "flt_lvl="+this.property(feature,'flt_lvl') + "&";
            if( this.property(feature,'cloud_cvg1') != undefined )
                statmodel = statmodel + "cover="+this.property(feature,'cloud_cvg1')+"&";
            else
                statmodel = statmodel + "cover=S&";
            if( this.property(feature,'cloud_bas1') != undefined )
                statmodel = statmodel + "cbas="+this.property(feature,'cloud_bas1') + "&";
            if( this.property(feature,'cloud_top1') != undefined )
                statmodel = statmodel + "ctop="+this.property(feature,'cloud_top1') + "&";
        }
        if( this.property(feature,'airep_type') == "Urgent PIREP" )
            color = "aa0000";
        if( text != "" )
            icon = this.icon_path+'/txticon.php?text='+text+'&color='+color;
        else if( statmodel != "" )
            icon = this.icon_path+'/stationicon.php?'+statmodel;
        else if( code == "PLANE" )
            icon = this.icon_path+'/wxicon.php?code='+code+'&color='+color+"&dir="+dir;
        else
            icon = this.icon_path+'/wxicon.php?code='+code+'&color='+color;
        icon = icon + "&scale=" + this.settings['scale'];
        return icon;
    }

    getLabel( feature ){
        if( this.property(feature,'airep_type') == "Urgent PIREP" )
            return "UUA "+this.property(feature,'flt_lvl');
        else if( this.settings['wxplot'] && (
                    this.property(feature,'temp') != undefined ||
                    this.property(feature,'wdir') != undefined ||
                    this.property(feature,'cloud_cvg1') != undefined ))
            return "";
        if( this.property(feature,'flt_lvl') == 0 &&
                this.property(feature,'flt_lvl_type') != undefined )
            return ""+this.property(feature,'flt_lvl_type');
        return ""+this.property(feature,'flt_lvl');
    }

    getStyle(feature, resolution ){
        let size = this.getIconSize(feature);
        let icon;
        if( this.icon_cache[ feature.getId()] )
            icon = this.icon_cache[feature.getId()];
        else {
            icon = new Icon({
                    "src": this.getIcon(feature),
                    "imgSize": [size,size]
                    });
            this.icon_cache[feature.getId()] = icon;
        }

        let style = new Style({
                "image": icon,
                "text": new Text({
                        "font": "12px",
                        "fill": new Fill({
                                "color": Library.parseHexColorToArray(this.getColor(feature))
                                }),
                        "text": this.getLabel(feature),
                        "stroke": new Stroke({"color": "white", "width": 2 }),
                        "textBaseline": "top",
                        "offsetX": 0,
                        "offsetY": 8
                        })
                });
        return style;
    }

   getSelectStyle(feature){
        console.info( "ss-p" );
        let size = this.getIconSize(feature);
        let icon;
        if( this.icon_cache[ feature.getId()] )
            icon = this.icon_cache[feature.getId()];
        else {
            icon = new Icon({
                    "src": this.getIcon(feature),
                    "imgSize": [size,size]
                    });
            this.icon_cache[feature.getId()] = icon;
        }

        let style = new Style({
                "image": icon,
                "text": new Text({
                        "font": "12px",
                        "fill": new Fill({
                                "color": Library.parseHexColorToArray(this.getHighlightColor(feature))
                                }),
                        "text": this.getLabel(feature),
                        "stroke": new Stroke({"color": "black", "width": 2 }),
                        "textBaseline": "top",
                        "offsetX": 0,
                        "offsetY": 8
                        })
                });
        return style;
    }

    getPopupText( feature ){
        let text = this.popupTitle( this.property(feature,'airep_type'), 
            this.property(feature,'ac_type'));
        text += this.popupData( "Obs Time", this.property(feature,'obs_time'));
        if( this.property(feature,'flt_lvl') !== undefined )
            text += this.popupData( "Flight level", this.property(feature,'flt_lvl'));
        if( this.property(feature,'flt_lvl_type') != undefined )
            text += this.popupData( "Flight level type", this.property(feature,'flt_lvl_type'));
        if( this.property(feature,'tb_int1') != undefined )
            text += this.popupData( "Turb intensity", this.property(feature,'tb_int1'));
        if( this.property(feature,'tb_type1') != undefined )
            text += this.popupData( "Turb type", this.property(feature,'tb_type1'));
        if( this.property(feature,'tb_freq1') != undefined )
            text += this.popupData( "Turb freqency", this.property(feature,'tb_freq1'));
        if( this.property(feature,'icg_int1') != undefined )
            text += this.popupData( "Icing intensity", this.property(feature,'icg_int1'));
        if( this.property(feature,'icg_type1') != undefined )
            text += this.popupData( "Icing type", this.property(feature,'icg_type1'));
        if( this.property(feature,'wdir') != undefined )
            text += this.popupData( "Wind", this.property(feature,'wdir')+" at " + this.property(feature,'wspd')+"knt:");
        if( this.property(feature,'temp') != undefined )
            text += this.popupData( "Temperature", this.property(feature,'temp')+"&deg;C");
        if( this.property(feature,'cloud_cvg1') != undefined )
            text += this.popupData( "Cloud Cover", this.property(feature,'cloud_cvg1'));
        if( this.property(feature,'cloud_top1') != undefined )
            text += this.popupData( "Cloud Top", this.property(feature,'cloud_top1'));
        if( this.property(feature,'cloud_bas1') != undefined )
            text += this.popupData( "Cloud Base", this.property(feature,'cloud_bas1'));
        if( this.property(feature,'cloud_cvg2') != undefined )
            text += this.popupData( "Cloud Cover2", this.property(feature,'cloud_cvg2'));
        if( this.property(feature,'cloud_top2') != undefined )
            text += this.popupData( "Cloud Top2", this.property(feature,'cloud_top2'));
        if( this.property(feature,'cloud_bas2') != undefined )
            text += this.popupData( "Cloud Base2", this.property(feature,'cloud_bas2'));
        if( this.property(feature,'wx_string') != undefined )
            text += this.popupData( "Weather", this.property(feature,'wx_string'));
        if( this.property(feature,'brk_action') != undefined )
            text += this.popupData( "Braking Action", this.property(feature,'brk_action'));
        text += this.popupSep();
        text += this.popupData( "", this.property(feature,'raw_ob') );
        text += this.popupEnd();
        return text;
    }

    setTypes(val, refresh = true){
        if( val == undefined ){
            let params = [];
            for( let i = 0; i < this.types.length; i++ ){
                if( Library.getCheckbox( "check_airep_types_"+this.types[i] )){
                    params.push( this.types[i]);
                }
            }
            this.settings['types'] = params.join(",");
        } else {
            let params = val.split(",");
            if( params[0] == "all" ){
                for( let i = 0; i < this.types.length; i++ )
                    Library.setCheckbox( "check_airep_types_"+this.types[i], true );
            } else {
                for( let i = 0; i < this.types.length; i++ )
                    Library.setCheckbox( "check_airep_types_"+this.types[i], false );
            }
            for( let i = 0; i < params.length; i++ )
                Library.setCheckbox( "check_airep_types_"+params[i], true );

            this.settings['types'] = val;
        }
        if( refresh ){
            this.refresh();
        }
    }

    updateLevel(){
        this.refresh();
    }

    updateTime(){
        this.refresh();
    }
}
